module.exports = __webpack_public_path__ + "img/16.6192b1c7.jpg";